import { Helper } from '../Helper';
export class RawIteratorSomeHelper extends Helper {
    constructor(options) {
        super();
        this.each = options.each;
    }
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.rawIteratorSomeBase({
            each: (innerOptions) => {
                sb.emitOp(node, 'DUP');
                sb.emitSysCall(node, 'Neo.Enumerator.Value');
                sb.emitOp(node, 'SWAP');
                sb.emitSysCall(node, 'Neo.Iterator.Key');
                this.each(innerOptions);
            },
        }));
    }
}

//# sourceMappingURL=RawIteratorSomeHelper.js.map
